module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/398.2864a559.png";